import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import pageHeaderStyle from "../assets/jss/components/pageHeaderStyle";
import yoma_group_logo from "../assets/img/yoma_group.png";
import Button from "@material-ui/core/Button";

function PageHeader({ ...props }) {
  const { classes, color, goToHomePage } = props;
  const appBarClasses = classNames({
    [" " + classes[color]]: color
  });

  return (
    <div className={classes.appBar + appBarClasses}>
      <div className={classes.container}>
        <div className={classes.flex}>
          <Button className="Ysh-Logo" onClick={() => goToHomePage()}>
            <img src={yoma_group_logo} alt="ysh-logo" width="207" height="50" />
          </Button>
        </div>
      </div>
    </div>
  );
}

PageHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary"])
};

export default withStyles(pageHeaderStyle)(PageHeader);
